import React from "react";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";
import differenceInDays from "date-fns/difference_in_days";
import format from "date-fns/format";

// note:
// new Date(Date.now()) is a roundabout way of getting the current time
// but it's useful for testing this functionality -- see PubDate-test.js

export default (dateTime, contentStatus, verbose = false) => {
  if (dateTime) {
    const month = verbose ? "MMMM" : "MMM";
    // Show relative time if article was published less than a day ago
    if (differenceInDays(dateTime, new Date(Date.now())) > -1) {
      // Less than an hour old: "[x] mins ago"
      // Less than a day but more than an hour: "[x] hrs ago"
      let distance = distanceInWordsStrict(new Date(Date.now()), dateTime, {
        addSuffix: true,
      });
      return distance.replace("minute", "min");
    }
    // Otherwise show the absolute date
    else {
      return format(dateTime, `${month} D, YYYY`);
    }
  } else {
    if (contentStatus && contentStatus !== "published") {
      return <i>unpublished</i>;
    } else {
      // Published items with a published date of null are a big no-no.
      // This maybe should even throw an error.
      return null;
    }
  }
};
